;(function (W, $, D, Drupal, drupalSettings) {

  'use strict'

  if (typeof W.sg === 'undefined') {
    W.sg = {}
  }

  let sg = W.sg, $D = $(D), $root = $('.paragraph--type--bloc-image-video'), transcriptionDeploy = false
  const oUtils = sg.utils

  let blocImageVideo = (() => {

    /**
     * @function toggleTranscription
     * Show/hide Transcription
     */
    let toggleTranscription = () => {
      $root.find('.toggle-transcription').on('click', (e) => {
        let $btn = $(e.currentTarget),
            target = $btn.attr('aria-controls'),
            mediaType = $btn.attr('data-mediatype')

        $('#' + target).slideToggle()
        transcriptionDeploy = !transcriptionDeploy

        let medialabel = mediaType === 'image' ? 'l\'image' : 'la vidéo',
            btnttext = (transcriptionDeploy) ? Drupal.t('Cacher la transcription de ' + medialabel, {}, {'context' : 'sg_refonte'}) : Drupal.t('Afficher la transcription de ' + medialabel, {}, {'context' : 'sg_refonte'})
        oUtils.toggleAriaExpanded($btn)
        $btn.text(btnttext)
      })
    },

    /**
     * @function createVideo
     * Add iframe YT when user click on BTN play
     */
    createVideo = (testConsent) => {
      let $aPlayer = $root.find('.media__icon--play')
      let $aCustomThumbnail = $aPlayer.parents('.media-wrapper').find('.custom-thumbnail');

      $aPlayer.map((i, el) => {
        let $player = $(el),
            $parent = $player.parents('.paragraph--type--bloc-image-video'),
            $fallback = $parent.find('.media-cookie-fallback'),
            $btnPlay = $parent.find('.media__icon--play')
        if(testConsent === true) {
          $player.on('click', (e) => {
            let $btn = $(e.currentTarget),
                iframeTitle = $parent.find('.media-wrapper').attr('data-title'),
                iframeUrl = $btn.attr('data-url'),
                iframeProvider = $btn.attr('data-b-provider'),
                analyticsLabel = drupalSettings.langcode === 'en' ? 'video_launch' : 'lancement_video'
            if(iframeUrl.length > 0){

              if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                  event: 'click',
                  id_composant: 'image_bloc',
                  event_name: window.dataLayer[0].pagename + '::' + oUtils.slugifyTag(iframeTitle) + '::' + analyticsLabel
                })
              }

              if (iframeProvider === 'youtube') {
                window.dataLayer = window.dataLayer || [];
                const mediaId = $btn.attr('data-id');

                $("<div id='player'>").appendTo($parent.find('.media--video'));

                const iframeUrlDecoded = decodeURIComponent(iframeUrl);
                const videoUrl = iframeUrlDecoded.split('url=')[1];
                let videoYoutubeUrl = videoUrl.split('?');
                if (videoYoutubeUrl[1]) {
                  videoYoutubeUrl = videoYoutubeUrl[1];
                } else {
                  videoYoutubeUrl = videoYoutubeUrl[0];
                }
                const videoUrlParams = videoYoutubeUrl.split('&');
                let videoIdParam = videoUrlParams.filter((param) => param.includes('v='))[0];
                if (!videoIdParam) {
                  videoIdParam = videoUrlParams.filter((param) => !param.includes('='))[0];
                }
                let videoId = videoIdParam.split('=');
                if (videoId[1]) {
                  videoId = videoId[1];
                } else {
                  videoId = videoId[0];
                  if (videoId.includes('/')) {
                    videoId = videoId.split('/').reverse();
                    videoId = videoId[0];
                  }
                }

                function sendAvEvent(event, currentTimeInMilliseconds) {
                  dataLayer.push({
                    'event': event,
                    'av_content_id': mediaId,
                    'av_content': iframeTitle,
                    'av_cursor_position': currentTimeInMilliseconds
                  });
                }

                function sendAvSeekEvent(event, lastPosition, currentPosition) {
                  dataLayer.push({
                    'event': event,
                    'av_content_id': mediaId,
                    'av_content': iframeTitle,
                    'av_old_cursor_position': lastPosition,
                    'av_new_cursor_position': currentPosition
                  });
                }

                function onYouTubeIframeAPIReady() {
                  new YT.Player('player', {
                    videoId: videoId,
                    events: {
                      'onReady': onPlayerReady,
                      'onStateChange': onPlayerStateChange
                    }
                  });
                }

                function onPlayerReady(event) {
                  event.target.playVideo();
                }

                let lastTimeInMilliseconds = 0;
                const threshold = 2;

                function onPlayerStateChange(event) {
                  const currentTime = event.target.getCurrentTime();
                  const currentTimeInMilliseconds = currentTime * 1000;
                  const timeDifference = Math.abs(currentTime - (lastTimeInMilliseconds / 1000));

                  let avEvent;
                  switch (event.data) {
                    case YT.PlayerState.PLAYING:
                      // Vérifier si l'utilisateur avance ou recule rapidement
                      if (timeDifference > threshold) {
                        if (currentTimeInMilliseconds > lastTimeInMilliseconds) {
                          //Fast forward detected
                          avEvent = 'av.forward';
                        } else {
                          //Rewind detected
                          avEvent = 'av.backward'
                        }
                      } else {
                        // Si la différence est inférieure au seuil, considérer que c'est une lecture normale
                        avEvent = 'av.play';
                      }
                      break;
                    case YT.PlayerState.PAUSED:
                      avEvent = 'av.pause';
                      break;
                    case YT.PlayerState.ENDED:
                      avEvent = 'av.stop';
                      break;
                    case YT.PlayerState.BUFFERING:
                      if (lastTimeInMilliseconds === 0) {
                        avEvent = 'av.buffer';
                      }
                      break;
                  }
                  if (avEvent) {
                    if (['av.forward', 'av.backward'].includes(avEvent)) {
                      console.log('avEvent', avEvent);
                      sendAvSeekEvent(avEvent, lastTimeInMilliseconds, currentTimeInMilliseconds);
                    } else {
                      console.log('avEvent', avEvent);
                      sendAvEvent(avEvent, currentTimeInMilliseconds);
                    }
                  }
                  if (event.data === YT.PlayerState.PLAYING) {
                    lastTimeInMilliseconds = currentTimeInMilliseconds; // Mettre à jour la dernière position connue
                  }
                }

                onYouTubeIframeAPIReady();
              } else {

                $('<iframe>', {
                  src: iframeUrl,
                  sandbox: 'allow-same-origin allow-scripts',
                  frameborder: 0,
                  title: iframeTitle
                }).appendTo($parent.find('.media--video'))

              }

              $btn.remove()
            }
            if (!$aCustomThumbnail.hasClass('hidden')) {
              $aCustomThumbnail.addClass('hidden');
            }

          })

          if(!$fallback.hasClass('hidden')){
            $fallback.addClass('hidden')
          }
          if($btnPlay.hasClass('hidden')){
            $btnPlay.removeClass('hidden')
          }
        } else {
          $fallback.removeClass('hidden')
          $btnPlay.addClass('hidden')
        }
      })
    },
    initVideoWithCookiesConsent = function(){
      var env = document.getElementsByTagName("html")[0].getAttribute("data-env");
      if (env === "local" || env === "int" || env === "test" || env === "preprod") {
        createVideo(true);
        return;
      }
      window.didomiOnReady = window.didomiOnReady || [];
      window.didomiOnReady.push(function (Didomi) {
        if (Didomi.isConsentRequired()) {
          Didomi.getObservableOnUserConsentStatusForVendor('c:youtube-3xUrMWqQ')
              .subscribe(function (consentStatusForVendor) {
                // The consent status for the vendor has changed
                if (consentStatusForVendor === true) {
                  createVideo(true)
                } else {
                  createVideo(false)
                }
              });
        }
      });
      window.didomiEventListeners = window.didomiEventListeners || [];
      window.didomiEventListeners.push({
        event: 'consent.changed',
        listener: function () {
          if (Didomi.isConsentRequired()) {
            Didomi.getObservableOnUserConsentStatusForVendor('c:youtube-3xUrMWqQ').subscribe(function (consentStatusForVendor) {
              // The consent status for the vendor has changed
              if (consentStatusForVendor === true) {
                createVideo(true);
              } else {
                createVideo(false);
              }
            });
          }
        }
      });
    },
    oMod = {
      init: () => {
        toggleTranscription()
      },
      initVideoWithCookiesConsent : initVideoWithCookiesConsent
    }

    return oMod
  })()
  blocImageVideo.initVideoWithCookiesConsent()
  $D.ready(function () {
    blocImageVideo.init()
  })

})(window, window.jQuery, document, window.Drupal, window.drupalSettings)
